import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-dashboard',
    template: `<div></div>`,
    standalone: false
})

export class DashboardComponent implements OnInit {

    activity: ActivityModel[] = [];

    constructor(
        private router: Router, private activityService: ActivityService
    ) { }

    ngOnInit() {
        this.activityService.getList().then(response => {
            this.activity = response;
            this.router.navigate(['/resume/' + this.activity[0].uid]);
        })

    }
}
